const pad = (value) => String(value).padStart(2, '0');

export const toIsoDate = (value) => {
  if (Array.isArray(value) && value.length === 3) {
    const [year, month, day] = value;
    return `${year}-${pad(month)}-${pad(day)}`;
  }
  return typeof value === 'string' && value ? value.slice(0, 10) : null;
};

// Same rule as the patientfi API: eligible from reapply_date onward, today taken in UTC.
export const isReapplyOpen = (reapplyDate, now = new Date()) => {
  const isoDate = toIsoDate(reapplyDate);
  return !isoDate || isoDate <= now.toISOString().slice(0, 10);
};

export const formatAccountDate = (value) => {
  const isoDate = toIsoDate(value);
  return isoDate
    ? new Intl.DateTimeFormat('en-US', { dateStyle: 'long', timeZone: 'UTC' }).format(
        new Date(`${isoDate}T00:00:00Z`)
      )
    : null;
};
